/**
 * Modular What's New entries for the "payroll" module: the employee self-service payslips screen. `routes` use the real navigation screen names from AppNavigator.jsx.
 *
 * @type {Object[]}
 */
const payrollEntries = [
  {
    id: 'payroll-my-payslips-2026-10',
    module: 'payroll',
    routes: ['MyPayslipsScreen'],
    date: '2026-10-23',
    version: '4.16.0',
    global: true,
    type: 'feature',
    title: {
      en: '🧾 Your payslips, always in your pocket',
      hu: '🧾 A bérjegyzékeid mindig a zsebedben',
      de: '🧾 Ihre Gehaltsabrechnungen, immer griffbereit',
      cn: '🧾 您的工资条，随时随地查看',
      ro: '🧾 Fluturașii tăi de salariu, mereu la îndemână',
      svn: '🧾 Vaše plačilne liste, vedno pri roki',
    },
    body: {
      en: 'Closed payslips are now listed month by month in the new “My payslips” screen, with your net pay at a glance. Tap one to open the PDF or share it, instead of waiting for a printout or an email.',
      hu: 'A lezárt bérjegyzékek mostantól hónapról hónapra megjelennek az új „Bérjegyzékeim” képernyőn, a kifizetendő nettó összeggel együtt. Koppints egyre, és megnyithatod vagy megoszthatod a PDF-et, ahelyett hogy nyomtatványra vagy e-mailre várnál.',
      de: 'Abgeschlossene Gehaltsabrechnungen erscheinen jetzt monatsweise im neuen Bildschirm „Meine Gehaltsabrechnungen“, mit Ihrem Nettobetrag auf einen Blick. Tippen Sie auf eine, um das PDF zu öffnen oder zu teilen, statt auf einen Ausdruck oder eine E-Mail zu warten.',
      cn: '已结算的工资条现在会按月份显示在全新的“我的工资条”页面中，实发金额一目了然。点击任意一条即可打开或分享 PDF，无需再等待纸质单据或邮件。',
      ro: 'Fluturașii închiși apar acum lună de lună în noul ecran „Fluturașii mei”, cu suma netă de plată la vedere. Atinge unul pentru a deschide sau a partaja PDF-ul, în loc să aștepți o listă tipărită sau un e-mail.',
      svn: 'Zaključeni obračuni plač so zdaj prikazani po mesecih na novem zaslonu »Moje plačilne liste«, z neto izplačilom na prvi pogled. Tapnite na enega, da odprete ali delite PDF, namesto da čakate na izpis ali e-pošto.',
    },
  },
];

export default payrollEntries;
